import { RecoverPage } from "@/features/auth/pages/Recover";

const Recover = () => {
  return <RecoverPage />;
};

export default Recover;
